// extracted by mini-css-extract-plugin
export var featured = "Featured-module--featured--1lDsJ";